// ** React
import { useEffect, useState } from "react";

// ** API
import articlesApi from "@/api/articles/api";

// ** MUI Imports
import { Box, Grid2 as Grid, Typography } from "@mui/material";

// ** Components Imports
import Pagination from "./Pagination";
import RecentlyPublishedCard from "./RecentlyPublishedCard";
import TagCard from "./TagCard";
import TopicCard from "./TopicCard";

function RecentlyPublished({ tags, topics, articles }) {
  const [articlesData, setArticlesData] = useState(articles);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchArticles = async () => {
      const response = await articlesApi.getPaginatedArticles(currentPage);
      setArticlesData(response);
    };
    fetchArticles();
  }, [currentPage]);

  return (
    <Grid container spacing={10} marginTop={"34px"} marginBottom={"34px"}>
      <Grid size={{ xs: 12, md: 8 }}>
        <Box
          sx={{ display: "flex", alignItems: "center", marginBottom: "30px" }}
        >
          <Box
            sx={{
              borderLeft: "3px solid rgb(226, 232, 240)",
              borderRight: "3px solid rgb(226, 232, 240)",

              width: "0px",
              height: { xs: "25px", sm: "35px" },
              borderRadius: "50px",
              marginRight: { xs: "10px", sm: "30px" },
            }}
          ></Box>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "20px", sm: "28px", lg: "34px" },
              fontWeight: 900,
              color: "#2D3748",
              marginRight: "8px",
              fontWeight: 700,
            }}
          >
            Recently Published
          </Typography>
        </Box>

        {articlesData.data?.map((item) => (
          <RecentlyPublishedCard
            key={item.documentId}
            topic={item.topic.name}
            topicSlug={item.topic.slug}
            title={item.name}
            slug={item.slug}
            description={item.shortDescription}
            articleImage={item.articleImageUrl}
            authorImage={item.authorImage}
            author={"Valentin-Marko Cîmpan"}
            date={item.updatedAt}
            readTime={"2min"}
          />
        ))}
      </Grid>
      <Grid
        component={"aside"}
        size={{ xs: 4 }}
        sx={{
          display: { xs: "none", md: "block" }, // Element will be removed from DOM at md breakpoint and up
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "24px" },
            fontWeight: 900,
            color: "rgb(113, 128, 150)",
            marginRight: "8px",
            fontWeight: 700,
            marginBottom: "34px",
          }}
        >
          Topics
        </Typography>
        <Box
          component={"ul"}
          sx={{
            maxHeight: "620px", // adjust
            overflowY: "auto",
            padding: "0px",
            pr: 2,
          }}
        >
          {topics.data?.map((topic) => (
            <Box
              key={topic.documentId}
              component={"li"}
              sx={{ listStyle: "none" }}
            >
              <TopicCard name={topic.name} slug={topic.slug} />
            </Box>
          ))}
        </Box>

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "24px" },
            fontWeight: 900,
            color: "rgb(113, 128, 150)",
            marginRight: "8px",
            fontWeight: 700,
            marginTop: "34px",
          }}
        >
          Tags
        </Typography>
        <TagCard tags={tags.data} />
      </Grid>
      <Grid size={{ xs: 0, sm: 1, md: 2, lg: 3 }}></Grid>
      <Grid size={{ xs: 12, sm: 10, md: 8, lg: 6 }} marginTop={"auto"}>
        {articlesData.data && (
          <Pagination
            currentPage={currentPage}
            totalPages={articlesData.meta.pagination.pageCount}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Grid>
      <Grid size={{ xs: 0, sm: 1, md: 2, lg: 3 }}></Grid>
    </Grid>
  );
}

export default RecentlyPublished;
